import validator from 'validator';
import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (values.url && !validator.isURL(values.url, { allow_underscores: true })) {
    errors.url = i18n.t("Please enter a valid link");
  }

  return errors;
};

export default validate;
